//dependecies
import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

// css
import css from "./Modal.module.scss";

// This component ensures that the modal is rendered at the root of the document to avoid z-index issues
export type BaseModalProps = {
	/**
	 * The content of the modal. Rendered in the body of the modal.
	 */
	children?: React.ReactNode;
};

const RootModal = ({ children }: BaseModalProps) => {
	const modalRoot = useRef(document.createElement("div"));

	// On mount we want to add a div to attach the panel to
	// On dismount we want to remove the div
	useEffect(() => {
		document.body.appendChild(modalRoot.current);

		return () => {
			modalRoot.current.remove();
		};
	}, []);

	return createPortal(<div className={css.modalOuterContainer}>{children}</div>, modalRoot.current);
};

export default RootModal;
